import * as types from "./AppTypes";

const INITIAL_STATE = {
  version: null,
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.SET_APP_VERSION:
      return {
        ...state,
        version: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
